import { AiChatServicePage } from './AiChatServicePage';

export default AiChatServicePage;
